function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuora = function SvgQuora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {
      fill: "#b0271e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.268 146.042c-5.684-.279-16.315-6.718-21.999-8.992-31.03-10.343-65.508-20.687-94.815-10.343-81.024 25.859-44.822 120.673-49.993 184.458 0 6.751-2.341 12.448-4.441 19.284l171.646 171.667c85.811-24.593 153.154-92.851 176.478-179.191z",
    style: {
      fill: "#961411"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.331 339.435s-1.434 21.037-20.558 21.037c-14.769 0-24.855-11.266-34.301-25.893 26.826-23.416 43.861-58.384 43.861-97.458 0-70.501-55.439-127.653-123.828-127.653s-123.828 57.153-123.828 127.653 55.439 127.654 123.828 127.654a120.4 120.4 0 0 0 35.697-5.394c14.302 22.721 32.458 43.151 60.88 43.151 57.849 0 60.24-63.097 60.24-63.097zm-134.825 4.303c-39.872 0-72.194-47.735-72.194-106.617s32.322-106.617 72.194-106.617S311.7 178.239 311.7 237.121c0 23.414-5.115 45.061-13.779 62.65-9.788-13.974-21.537-25.872-38.334-29.661-29.798-6.72-55.46 6.694-63.588 13.388l7.649 15.777s7.733-4.446 26.908-.005c12.081 2.798 21.471 19.565 32.23 38.802-7.303 3.672-15.135 5.666-23.28 5.666",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.331 339.435s-1.434 21.037-20.559 21.037c-14.769 0-24.855-11.266-34.301-25.893 26.827-23.416 43.861-58.384 43.861-97.458 0-70.501-55.439-127.653-123.828-127.653q-.085.001-.169.005v21.039c.057 0 .112-.007.169-.007 39.872 0 72.194 47.735 72.194 106.617 0 23.414-5.115 45.061-13.779 62.65-9.788-13.974-21.537-25.872-38.334-29.661-7.04-1.588-13.846-2.041-20.249-1.734v35.576c8.175 6.834 15.432 19.787 23.45 34.12-7.304 3.674-15.134 5.668-23.28 5.668-.057 0-.112-.007-.169-.007v21.039c.057 0 .112.005.169.005a120.4 120.4 0 0 0 35.697-5.394c14.302 22.721 32.458 43.151 60.88 43.151 57.849 0 60.24-63.097 60.24-63.097h-21.992z",
    style: {
      fill: "#d1d1d1"
    }
  }));
};
export default SvgQuora;